export const purchaseUrl = 'https://entrenamiento-en-casa.impultienda.ar/checkout'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/4HBJWANXKGrtJpf9acybnn/ChatGPT_Image_30_ago_2026,_10_01_20_p.m..png'

export const heroStats = [
  ['+200', 'personas entrenan'],
  ['5', 'módulos completos'],
  ['3', 'bonos gratis'],
  ['4,9/5', 'calificación ⭐'],
] as const

export const testimonials = [
  {
    initials: 'MG',
    name: 'Martín G.',
    place: 'Buenos Aires',
    text: 'Organicé todo el programa en una tarde. El banco de ejercicios me ahorra 3 horas cada semana.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    place: 'Córdoba',
    text: 'Finalmente un programa que respeta mi tiempo. Las rutinas funcionan de verdad.',
  },
  {
    initials: 'DM',
    name: 'Diego M.',
    place: 'Rosario',
    text: 'Sin gimnasio, sin máquinas caras. Solo resultados reales con bandas.',
  },
]

export const developedTestimonials = [
  {
    initials: 'MG',
    name: 'Martín G.',
    place: 'Buenos Aires · 38 años · Trabajador independiente',
    result: 'De 2 a 6 entrenamientos por semana',
    text: 'Organicé todo el programa en una tarde. El banco de ejercicios me ahorra 3 horas cada semana de planificación. Ahora abro el PDF de la fase que toca, entreno 40 minutos y listo. Pasé de entrenar dos veces por semana a seis, sin pisar un gimnasio.',
  },
  {
    initials: 'LV',
    name: 'Lucía V.',
    place: 'Córdoba · 34 años · Ejecutiva',
    result: 'Cambios visibles en 2 meses',
    text: 'Tenía miedo a lesionarme entrenando sola en casa. Con el Módulo 1 entendí la técnica de cada ejercicio y los errores que venía cometiendo hace años. A los dos meses vi cambios reales en brazos y piernas, y por primera vez no me dolió la espalda.',
  },
  {
    initials: 'DM',
    name: 'Diego M.',
    place: 'Rosario · 41 años · Emprendedor',
    result: '6 meses sin abandonar',
    text: 'Sin gimnasio, sin máquinas caras, sin excusas. Las rutinas progresivas funcionan de verdad: cada bloque de semanas sube la exigencia justa. Terminé las 24 semanas completas, algo que nunca había logrado con ningún plan.',
  },
  {
    initials: 'CR',
    name: 'Carolina R.',
    place: 'Mendoza · 29 años · Docente',
    result: '−7 kg y rutina estable',
    text: 'Las rutinas express del Módulo 5 me salvaron. Los días de mucho trabajo hago 20 minutos y no rompo la cadena. Con el recetario acomodé las comidas y bajé 7 kilos sin dietas raras ni pasar hambre.',
  },
  {
    initials: 'SF',
    name: 'Sebastián F.',
    place: 'La Plata · 46 años · Contador',
    result: 'Salió del estancamiento',
    text: 'Ya entrenaba con bandas pero hacía siempre lo mismo y estaba estancado. Los protocolos de tempo y las series cluster de la Fase 3 me destrabaron por completo. A los 41 y trabajando sentado todo el día, hoy estoy más fuerte que a los 30.',
  },
]

export const modules = [
  {
    icon: '📘',
    name: 'Módulo 1 — Biblioteca de ejercicios',
    period: 'Semanas 1-2 · Fundamentos',
    content: [
      '35 ejercicios con bandas (técnica perfecta paso a paso)',
      'Errores comunes y cómo corregirlos',
      'Regresiones y progresiones para cada movimiento',
      'Series, repeticiones y descanso optimizado',
      'Conexión mente-músculo para cada ejercicio',
    ],
  },
  {
    icon: '🔰',
    name: 'Módulo 2 — Fase 1: Adaptación',
    period: 'Semanas 3-8 · Base de fuerza',
    content: [
      '6 rutinas progresivas (días completos armados)',
      'Adaptación neuromuscular del cuerpo',
      'Aumento gradual de resistencia',
      'Plantillas de seguimiento incluidas',
      'Calendario semana a semana',
    ],
  },
  {
    icon: '💪',
    name: 'Módulo 3 — Fase 2: Tonificación',
    period: 'Semanas 9-16 · Volumen muscular',
    content: [
      '6 rutinas avanzadas (split por grupos musculares)',
      'Protocolo de hipertrofia muscular',
      'Tempo de movimiento optimizado',
      'Tablas de progresión de cargas',
      'Estrategia de series y repeticiones',
    ],
  },
  {
    icon: '🔥',
    name: 'Módulo 4 — Fase 3: Intensidad',
    period: 'Semanas 17-24 · Definición',
    content: [
      '6 rutinas de máxima intensidad',
      'Dropsets y series cluster',
      'Conexión mente-músculo avanzada',
      'Protocolo de 12 semanas de intensidad',
      'Técnicas de intensidad comprobadas',
    ],
  },
  {
    icon: '⏱️',
    name: 'Módulo 5 — Rutinas express + Continuidad',
    period: 'Flexibilidad + Plan post-programa',
    content: [
      '15 rutinas express (15-30 minutos)',
      'Calendario anual de entrenamientos',
      'Hoja de registro y seguimiento',
      'Plan de continuidad (qué hacer después)',
      'Estrategias para mantener resultados',
    ],
  },
  {
    icon: '🧩',
    name: 'Bonus — Preguntas + Casos',
    period: 'Casos prácticos resueltos',
    content: [
      '50 preguntas frecuentes respondidas',
      'Casos de estancamiento y cómo salir',
      'Resolución de problemas comunes',
      'Estrategias para mantener consistencia',
      'Solución de dudas técnicas',
    ],
  },
]

export const bonuses = [
  {
    number: '01',
    icon: '🥗',
    name: 'Recetario Fit Express',
    description:
      'Recetas saludables, rápidas y simples para desayunos, almuerzos, cenas y snacks que potencian tu entrenamiento.',
    tags: [
      'Desayunos energéticos',
      'Almuerzos proteicos',
      'Cenas ligeras',
      'Snacks inteligentes',
      'Ingredientes simples',
    ],
    value: '$12.000 ARS',
  },
  {
    number: '02',
    icon: '🍫',
    name: 'Dulces Fit Sin Culpa',
    description:
      'Postres y snacks dulces saludables para disfrutar sin abandonar tu progreso ni sentir culpa.',
    tags: [
      'Postres fit',
      'Snacks dulces',
      'Meriendas saludables',
      'Antojos controlados',
      'Sin refinados',
    ],
    value: '$10.000 ARS',
  },
  {
    number: '03',
    icon: '🍳',
    name: 'Cocina Simple Para No Abandonar',
    description:
      'Guía de comidas fáciles, combinaciones rápidas, recetas base y lista de compras para toda la semana.',
    tags: [
      'Comidas simples',
      'Combinaciones rápidas',
      'Recetas base',
      'Lista de compras',
      'Organización semanal',
    ],
    value: '$12.000 ARS',
  },
] as const

export const pains = [
  {
    title: 'Entrenamientos sin progresión',
    text: 'Hacés los mismos ejercicios cada semana y tu cuerpo no cambia. La monotonía mata los resultados.',
  },
  {
    title: 'No sabés cómo avanzar',
    text: '¿Cuándo cambiás de rutina? ¿Cómo lo hacés? Sin un plan, solo perdés tiempo y motivación.',
  },
  {
    title: 'Bandas elásticas sin saber usarlas',
    text: 'Están en tu casa pero no les sacás ni el 20% de su potencial real.',
  },
  {
    title: 'Miedo a lesionarte',
    text: 'Sin técnica correcta cada entrenamiento es un riesgo: dolor en hombros, espalda y rodillas.',
  },
  {
    title: 'Motivación que cae a las 4 semanas',
    text: 'Porque no ves resultados ni tenés un plan que seguir. Y volvés a abandonar.',
  },
]

export const faqs = [
  [
    '¿Es para principiantes o para personas que ya entrenan?',
    'Es para ambos. El Módulo 1 comienza desde cero con técnica perfecta. Si ya entrenás, acelerás con los Módulos 3 y 4. El programa se adapta a tu nivel actual.',
  ],
  [
    '¿Necesito bandas elásticas específicas?',
    'No. Funciona con cualquier banda elástica que tengas. El programa te enseña a usar resistencia variable con las que ya tenés en casa. Si no tenés, te recomendamos un set básico (~$1.500 ARS).',
  ],
  [
    '¿Cómo recibo el material?',
    'Apenas pagás recibís un email con el link de descarga. Son 5 archivos PDF que descargás a tu computadora, tablet o teléfono. Acceso de por vida, sin límites.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí, 7 días para probarlo. Si no cumple, te devolvemos el 100% de tu dinero. Sin explicaciones, sin drama: escribís a compradigitalyaa@gmail.com y listo.',
  ],
  [
    '¿Puedo pagar en cuotas?',
    'Sí, con Mercado Pago. Sin interés hasta 12 cuotas. También aceptamos tarjeta de crédito/débito y transferencia bancaria.',
  ],
  [
    '¿Qué pasa después de los 6 meses?',
    'El Módulo 5 incluye el plan de continuidad completo. Mantenés los resultados con rutinas express y podés reiniciar el ciclo con más intensidad o pasar a mantenimiento.',
  ],
  [
    '¿Necesito experiencia previa en entrenamiento?',
    'No. El programa comienza desde cero. Pero si tenés experiencia, vas a aprender técnicas avanzadas en los Módulos 3 y 4.',
  ],
  [
    '¿Puedo imprimirlo?',
    'Sí. Son PDF que podés imprimir, aunque te recomendamos la versión digital por portabilidad. El acceso es de por vida.',
  ],
  [
    '¿Cuánto tiempo por día necesito?',
    'Entre 30 y 45 minutos, 3 a 5 días por semana. Si tenés un día complicado, usás una de las 15 rutinas express de 15 a 30 minutos y no rompés la cadena.',
  ],
  [
    '¿Sirve si tengo poco espacio en casa?',
    'Sí. Todo el programa está diseñado para un espacio del tamaño de una colchoneta. No necesitás máquinas, banco ni equipamiento pesado: solo tus bandas.',
  ],
] as const

export const recentPurchases = [
  ['Camila Ferreyra', 'Rosario, Santa Fe'],
  ['Julián Ibáñez', 'Córdoba Capital, Córdoba'],
  ['Rocío Maidana', 'La Plata, Buenos Aires'],
  ['Agustina Rojas', 'Godoy Cruz, Mendoza'],
  ['Belén Sosa', 'Mar del Plata, Buenos Aires'],
  ['Martín Quiroga', 'San Miguel de Tucumán, Tucumán'],
  ['Lucía Benítez', 'Neuquén Capital, Neuquén'],
  ['Natalia Ojeda', 'Salta Capital, Salta'],
  ['Federico Arrieta', 'Bahía Blanca, Buenos Aires'],
  ['Sofía Cabrera', 'Paraná, Entre Ríos'],
] as const
